import { render, staticRenderFns } from "./LAHeader.vue?vue&type=template&id=5177cd34&scoped=true"
import script from "./LAHeader.vue?vue&type=script&lang=js"
export * from "./LAHeader.vue?vue&type=script&lang=js"
import style0 from "./LAHeader.vue?vue&type=style&index=0&id=5177cd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177cd34",
  null
  
)

export default component.exports